import * as Yup from 'yup';
Yup.setLocale({
    mixed: {
        required: 'Dieses Feld muss ausgefüllt sein',
        oneOf: 'Dieses Feld muss einen der folgenden Werte haben: ${values}',
        notOneOf: 'Dieses Feld darf keinen der folgenden Werte haben: ${values}',
    },
    string: {
        length: '${path} muss genau ${length} Zeichen lang sein',
        min: '${path} muss mindestens ${min} Zeichen lang sein',
        max: '${path} darf höchstens ${max} Zeichen lang sein',
        matches: '${path} muss wie folgt aussehen: "${regex}"',
        email: '${path} muss eine gültige E-Mail-Adresse enthalten',
        url: '${path} muss eine gültige URL sein',
        trim: '${path} darf keine Leerzeichen am Anfang oder Ende enthalten',
        lowercase: '${path} darf nur Kleinschreibung enthalten',
        uppercase: '${path} darf nur Großschreibung enthalten',
    },
    number: {
        min: '${path} muss größer oder gleich ${min} sein',
        max: '${path} muss kleiner oder gleich ${max} sein',
        lessThan: '${path} muss kleiner sein als ${less}',
        moreThan: '${path} muss größer sein als ${more}',
        positive: '${path} muss eine positive Zahl sein',
        negative: '${path} muss eine negative Zahl sein',
        integer: '${path} muss eine ganze Zahl sein',
    },
    date: {
        min: '${path} muss später sein als ${min}',
        max: '${path} muss früher sein als ${max}',
    },
    object: {
        noUnknown: '${path}-Feld darf keine Schlüssel verwenden, die nicht im "Objekt-Shape" definiert wurden',
    },
    array: {
        min: params => `Dieses Feld muss ausgefüllt sein`,
        max: params => `Dieses Feld muss weniger oder genau ${params.max === 1 ? 'einen Eintrag' : `${params.max} Einträge`} haben`,
    },
    boolean: {
        isValue: params => {
            if (Boolean(params.value) === true) {
                return 'Dieses Feld muss aktiviert sein';
            }
            if (Boolean(params.value) === false) {
                return 'Dieses Feld darf nicht aktiviert sein';
            }
            return 'Ungültiger Wert';
        },
    },
});
export default Yup;
